module.exports = __webpack_public_path__ + "img/thumbnail_CommonOstrich_m_albino.6377da08.png";